import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * SN 產品名稱對照詳情。
 * GET `/aftersales/sn-product-mapping/{id}`
 *
 * @param {string} id
 */
export async function fetchSnProductMappingDetail(id) {
  const { data: raw } = await request.get(`/aftersales/sn-product-mapping/${id}`);
  return parseVer4DetailResponse(raw);
}
